import dayjs from "dayjs";

export const getDaysInMonth = (year, month) => dayjs(`${year}-${String(month).padStart(2, "0")}-01`).daysInMonth();

export const clampDayToMonth = (day, year, month) => Math.min(day, getDaysInMonth(year, month));

export const buildDayOptions = (year, month) =>
  Array.from({ length: getDaysInMonth(year, month) }, (_, index) => ({
    label: String(index + 1),
    value: index + 1,
  }));
